module.exports = __webpack_public_path__ + "img/21.090ef334.jpg";